import React from 'react';
import { motion } from 'framer-motion';
const HEADSHOT_URL = 'https://cdn.magicpatterns.com/uploads/6BHUD5Tma6heQ6HkVAU1Hr/SMeyer3.jpg';
export function Hero() {
  return <section id="hero" className="relative bg-navy pt-40 pb-20 lg:pt-48 lg:pb-28" data-id="element-118" data-mp="9ktetq07k6yt">
      <div className="max-w-content mx-auto px-6 lg:px-10 flex flex-col items-center text-center" data-id="element-119" data-mp="9igxnf29y0mt">
        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.7,
        ease: [0.23, 1, 0.32, 1]
      }} className="relative w-56 sm:w-64" data-id="element-120" data-mp="4jvv38zjv4v7">
          <span className="absolute -top-3 -left-3 h-8 w-8 border-t-2 border-l-2 border-gold" aria-hidden="true" data-id="element-121" data-mp="sarsqmqosuad" />
          <span className="absolute -top-3 -right-3 h-8 w-8 border-t-2 border-r-2 border-gold" aria-hidden="true" data-id="element-122" data-mp="nb6llp1d5fmk" />
          <span className="absolute -bottom-3 -left-3 h-8 w-8 border-b-2 border-l-2 border-gold" aria-hidden="true" data-id="element-123" data-mp="3d33fx1m3uzmc" />
          <span className="absolute -bottom-3 -right-3 h-8 w-8 border-b-2 border-r-2 border-gold" aria-hidden="true" data-id="element-124" data-mp="384jssxvrzhse" />
          <div className="border border-gold/70 bg-navy-light p-2.5" data-id="element-125" data-mp="3o7lshs6gf8ph">
            <img src={HEADSHOT_URL} alt="Portrait of Stephanie Meyer" className="w-full aspect-[4/5] object-cover" data-id="element-126" data-mp="3o6u7fbahgtdg" />
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.7,
        ease: [0.23, 1, 0.32, 1],
        delay: 0.15
      }} className="mt-10 max-w-3xl" data-id="element-127" data-mp="3ebirwqr93i4n">
          <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight text-white" data-id="element-128" data-mp="2qk3k4igpg8m0">
            Stephanie Meyer
          </h1>
          <p className="mt-6 text-base sm:text-lg leading-relaxed text-slate-300" data-id="element-129" data-mp="2vjg5eyrxh7mh">
            International Executive | Board Director | Global Growth, Transformation &amp; Enterprise
            Leadership
          </p>
          <p className="mt-6 text-sm sm:text-[15px] text-slate-400 tracking-wide" data-id="element-130" data-mp="2lmuyg7wclmg0">
            Luxembourg&nbsp;&nbsp;|&nbsp;&nbsp;stephanie.meyer@totalmedia.lu&nbsp;&nbsp;|&nbsp;&nbsp;+352 621 253 609
          </p>

          <div className="mt-10" data-id="element-131" data-mp="ic87ve5ce4xb">
            <a href="#contact" className="inline-flex items-center justify-center bg-gold px-8 py-3.5 text-sm font-semibold tracking-wide text-navy hover:bg-gold-light transition-colors duration-200" data-id="element-132" data-mp="id9umfvq0fuv">
              Submit a Board Inquiry
            </a>
          </div>
        </motion.div>
      </div>
    </section>;
}